import { render, staticRenderFns } from "./JdpTestAdmin.vue?vue&type=template&id=b54d92dc&scoped=true&"
import script from "./JdpTestAdmin.vue?vue&type=script&lang=ts&"
export * from "./JdpTestAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54d92dc",
  null
  
)

export default component.exports